export const HTTP_STATUS_4XX = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
};

export const HTTP_STATUS_6XX = {
  SESSION_EXPIRED: 612,
  INVALID_MFA_CODE: 632,
  UNAUTHORIZED_TASK: 642,
  PASSWORD_EXPIRED: 663,
};
